import { useCart } from '../../contexts/CartContext';

export default function CartIcon() {
  const { cartCount, openCart } = useCart();

  return (
    <button
      onClick={openCart}
      className="relative w-10 h-10 flex items-center justify-center text-white hover:bg-white/10 rounded-lg transition-colors"
    >
      <i className="ri-shopping-bag-3-line text-xl"></i>
      {cartCount > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 bg-white text-black text-xs font-black rounded-full flex items-center justify-center">
          {cartCount > 9 ? '9+' : cartCount}
        </span>
      )}
    </button>
  );
}